module.exports = __webpack_public_path__ + "static/media/login-background.68ddb1a0.png";